import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  hasText?: boolean;
  multipleVariations?: boolean;
}

const VariationTwoUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  hasText,
  multipleVariations,
}) => {
  const settingsApplied = Boolean(
    image.divider !== 'none' ||
      image.brakes ||
      !image.quotes ||
      image.fontSize ||
      getWatermarkTag(image) !== 'none',
  );

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      showText={!!hasText}
      settingsApplied={settingsApplied}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          multipleVariations={multipleVariations}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(VariationTwoUploadedImageRow);
